import { render, staticRenderFns } from "./SecondObjCC.vue?vue&type=template&id=a5d32280&scoped=true"
import script from "./SecondObjCC.vue?vue&type=script&lang=js"
export * from "./SecondObjCC.vue?vue&type=script&lang=js"
import style0 from "./SecondObjCC.vue?vue&type=style&index=0&id=a5d32280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d32280",
  null
  
)

export default component.exports